/** 第三方支付类型 */
export const PAY_THIRD_TYPE = {
  /** 连连 */
  LIANLIAN: 0,
  /** 易宝 */
  YEEPAY: 1,
}

/** 连连开户状态 */
export const LIANLIAN_OPEN_STATUS = {
  /** 未申请 */
  NOTYET: 0,
  /** 已保存资料, 申请中 */
  SAVE: 1,
  /** 已提交申请到连连等待验证, 申请中 */
  SUBMIT: 2,
  /** 提交资料连连失败, 审核失败 */
  FAIL: 3,
  /** 审核中 */
  AUDITING: 4,
  /** 审核失败 */
  FAILURE: 5,
  /** 审核成功, 已开户 */
  SUCCESS: 6,
  /** 待激活 */
  WAIT_ACTIVE: 7,
}
/** 易宝开户状态 */
export const YEE_OPEN_STATUS = {
  /** 请求失败 */
  FAIL: -1,
  /** 待开户 */
  WAIT: 0,
  /** 申请审核中 */
  APPLYING: 1,
  /** 申请已驳回 */
  REJECT: 2,
  /** 真实性验证中 */
  VERIFYING: 3,
  /** 协议待签署 */
  SIGNING: 4,
  /** 业务开通中 */
  OPENING: 5,
  /** 申请已完成 */
  SUCCESS: 6,
}
